import { computed, Directive, HostBinding, inject, input } from '@angular/core';
import { BranchRole, LocationRole, SystemRole } from '../types';
import { UserLoginService } from '../service/user-login.service';
import { intersection } from 'lodash';

@Directive({
  selector: '[panRole]',
  standalone: true,
})
export class RoleDirective {
  private userLogin = inject(UserLoginService);

  public roles = input<(SystemRole | BranchRole | LocationRole)[]>();

  public hasAnyRole = computed(() => {
    const requiredRoles = this.roles();
    const allOfMyRoles = this.userLogin.currentProfileRoleList();

    // admins get to see everything anyway
    if (this.userLogin.currentUserIsAdmin()) return true;

    // otherwise, we check if we have any of the required roles
    return intersection(requiredRoles, allOfMyRoles).length > 0;
  });

  @HostBinding('class.!hidden')
  get isHidden() {
    return !this.hasAnyRole();
  }
}
